<!-- <div class="nav p-0 m-0 col-12 flex-xg-row flex-lg-row w-100 flex-md-column flex-sm-column font-dark align-items-center" id="btn-continue">
          <button type="button" class="btn btn-sm btn-usblick">Continue</button>
</div> -->
<div #gmap style="width:100% !important; height:520px !important" class="mb-3">

</div>